import React from 'react';
import PropTypes from 'prop-types';
import { FAIcon } from '../fa-icon/component.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';

var ComplexTableColumn = function ComplexTableColumn(_ref) {
  var columnConfig = _ref.columnConfig,
      header = _ref.header,
      headerIcon = _ref.headerIcon,
      _ref$headerSize = _ref.headerSize,
      headerSize = _ref$headerSize === void 0 ? 16 : _ref$headerSize;

  var headerClassName = _formatClassName(['complex-column-header', "complex-column-header-".concat(headerSize)]);

  var renderColumnConfig = function renderColumnConfig() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, columnConfig.map(function (row) {
      if (Array.isArray(row)) {
        return /*#__PURE__*/React.createElement("div", {
          className: "complex-column-row",
          key: row.label
        }, row.map(function (subRow) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, subRow.label && /*#__PURE__*/React.createElement("div", {
            className: "complex-column-value"
          }, subRow.icon && /*#__PURE__*/React.createElement(FAIcon, {
            icon: subRow.icon
          }), subRow.label));
        }));
      } else {
        return /*#__PURE__*/React.createElement(React.Fragment, null, row.label && /*#__PURE__*/React.createElement("div", {
          className: "complex-column-row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "complex-column-value"
        }, row.icon && /*#__PURE__*/React.createElement(FAIcon, {
          iconType: row.icon
        }), row.label)));
      }
    }));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "complex-table-column"
  }, header && /*#__PURE__*/React.createElement("div", {
    className: headerClassName
  }, headerIcon && /*#__PURE__*/React.createElement(FAIcon, {
    icon: headerIcon
  }), header), columnConfig && renderColumnConfig());
};

ComplexTableColumn.displayName = "ComplexTableColumn";
ComplexTableColumn.propTypes = {
  columnConfig: PropTypes.arrayOf(PropTypes.shape({
    columnRow: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      icon: PropTypes.string
    })), PropTypes.shape({
      label: PropTypes.string,
      icon: PropTypes.string
    })])
  })),
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  headerIcon: PropTypes.string,
  headerSize: PropTypes.oneOf([14, 16, 18])
};
export { ComplexTableColumn };